"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeocodingResult = function GeocodingResult(address, lat, lng) {
	_classCallCheck(this, GeocodingResult);

	this.address = address;
	this.lat = lat;
	this.lng = lng;
};

;

module.exports = GeocodingResult;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/geocoding-result.js
// module id = 12
// module chunks = 0